export default __webpack_public_path__ + "static/media/cscenter_banner.4a1b44b1.png";